import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/translate.service.ts